import Button from 'src/Components/Button/Button';
import './NoLicenseActivated.css'
import { Trans, useTranslation } from 'react-i18next';
import { useEffect, useMemo, useState } from 'react';
import { InfoMessageType } from 'src/Components/InfoBar/InfoBar';
import LicensePayment from '../Payment/LicensePayment';
import { useGetPaymentProducts } from 'src/Utils/Hooks/Payments/useGetPaymentProducts';
import { AuraSuiteIcon } from 'src/SharedComponents/Icons/Icons';

type INoLicenseActivated = {
    clinicId: string;
    updatePageLoader: (load: boolean) => void;
    setInfo: (message: string, type: InfoMessageType) => void;
    showPaymentOption: boolean;
    isClinicAdmin: boolean;
}
const NoLicenseActivated: React.FC<INoLicenseActivated> = ({clinicId, updatePageLoader, setInfo, showPaymentOption, isClinicAdmin }) => {
    const { t } = useTranslation();
    const [showLicensePaymentDialog, setShowLicensePaymentDialog] = useState<boolean>(false);
    const {products, reqestError, reqestLoading, getPaymentProducts} = useGetPaymentProducts();

    useEffect(() => {
        updatePageLoader(reqestLoading) 
    }, [reqestLoading, updatePageLoader]);

    useEffect(() => {
        if (reqestError !== '') {
            setInfo(reqestError, InfoMessageType.error);
        } 
    },[reqestError, setInfo]);
    
    useEffect(() => {
        if(showPaymentOption) {
             getPaymentProducts(clinicId);
        }
    }, [getPaymentProducts, clinicId, showPaymentOption]);

    const isButtonDisabled = useMemo(() => {
        return !products?.suiteProductComboInfos?.length;
    }, [products]);

    return (
        <>
            {
                showLicensePaymentDialog && 
                products &&
                    <LicensePayment
                       clinicId={clinicId}
                       products={products}
                       updatePageLoader={updatePageLoader}
                        onClose={()=>{setShowLicensePaymentDialog(false)}}
                        setInfo={setInfo}
                    />
            }
            {   showPaymentOption &&
                <div className='noLicenseContainer'>
                    <div className="row">
                        <div className='title'>{t('ThankYouForAura')}</div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-4 text-end d-flex align-items-center justify-content-end">
                            <AuraSuiteIcon />
                        </div>
                        <div className="col-8 text-start">
                            <span className="noLicensefooter">
                                <Trans i18nKey="AuraPurchase"/>
                            </span>
                        </div>
                    </div>
                    <div className="pt-5">
                        <Button
                            width='56%'
                            text={t('DiscoverAuraSuites')}
                            onClick={() => setShowLicensePaymentDialog(true)}
                            disable={isButtonDisabled || !isClinicAdmin}
                        />
                    </div>
                </div>
            }
            {
                !showPaymentOption &&        
                <div className='noLicenseContainer'>
                    <div className="row">
                        <span style={{fontSize: '20px', fontWeight: 500, color: 'var(--color-primary)'}}>{t('NoLicensesAssigned')}</span>
                    </div>
                    <div className="row mt-4">
                        <span>{t('NeedAuraLicenseToUse')}</span>
                        <span>{t('ContactYourDistributor')}</span>
                    </div>
                    <div className="row mt-4">
                        <span>{t('DownloadAuraAppInstruction')}</span>
                    </div>
                </div>
            }
        </>
    )
}
export default NoLicenseActivated